import { actions } from "./Reducer";

//sign up Admin 
export const signupAdminAction = (formData, redirect) => ({
  type : actions.SIGNUP_ADMIN,
  payload : formData,
  redirect
})

export const signupAdminSuccessAction = payload => ({
  type : actions.SIGNUP_ADMIN_SUCCESS,
  payload
})

// Sign up Artisan
export const signupArtisanAction = formData => ({
  type: actions.SIGNUP_ARTISAN,
  payload: formData
});

export const signupArtisanSuccessAction = payload => ({
  type: actions.SIGNUP_ARTISAN_SUCCESS,
  payload
});

// Sign up Supplier 

export const signupSupplierAction = formData => ({
  type:actions.SIGNUP_SUPPLIER,
  payload: formData
})

export const signupSupplierSuccessAction = payload => ({
  type: actions.SIGNUP_SUPPLIER_SUCCESS,
  payload
})

// Sign Up Customer 
export const signupCustomerAction = formData => ({
  type: actions.SIGNUP_CUSTOMER,
  payload: formData
});

export const signupCustomerSuccessAction = payload => ({
  type: actions.SIGNUP_CUSTOMER_SUCCESS,
  payload
});


// login 

export const loginUserAction = (formData, expiretionDate) => ({
  type: actions.LOGIN_USER,
  payload: formData,
  expiretionDate
});


export const setUserProfiles = (profiles) =>({
  type: actions.SET_USER_PROFILES,
  payload: profiles
})




export const loginUserSuccessAction = (user, token) => ({
  type: actions.LOGIN_USER_SUCCESS,
  payload: { user, token },
});


// logout 
export const logoutUserAction = () => ({
  type: actions.LOGOUT_USER,
});

export const logoutUserSuccessAction = () => ({
  type : actions.LOGOUT_USER_SUCCESS
})

// forgot Password



export const forgotPasswordAction = (payload) => ({
  type: actions.FORGOT_PASSWORD,
  payload

})

export const forgotPasswordSuccessAction = () => ({
  type: actions.FORGOT_PASSWORD_SUCCESS
})


// reset password

export const resetPasswordAction = (token, password) => ({
  type:actions.RESET_PASSWORD,
  payload : {
    token,
    password
  }
})



// Update Profiles

export const updateAuthArtisanAction = (body) => ({
  type: actions.UPDATE_AUTH_ARTISAN,
  payload: body
})

export const updateAuthArtisanSuccessAction = (update) => ({
  type: actions.UPDATE_AUTH_ARTISAN_SUCCESS,
  payload: update
})

export const updateAuthCustomerAction = (body) => ({
  type: actions.UPDATE_AUTH_CUSTOMER,
  payload: body
})



export const updateAuthCustomerSuccessAction = (update) => ({
  type: actions.UPDATE_AUTH_CUSTOMER_SUCCESS,
  payload: update
})
export const updateAuthSupplierAction = (body) => ({
  type: actions.UPDATE_AUTH_SUPPLIER,
  payload: body
})
export const updateAuthApplicantAction = (body) => ({
  type: actions.UPDATE_AUTH_APPLICANT,
  payload: body
})


export const updateAuthSupplierSuccessAction = (update) => ({
  type: actions.UPDATE_AUTH_SUPPLIER_SUCCESS,
  payload: update
})

export const updateAuthApplicantSuccessAction = (update) => ({
  type: actions.UPDATE_AUTH_APPLICANT_SUCCESS,
  payload: update
})

/**
 * Misc
 */

export const setAuthIsLoadingAction = isLoading => ({
  type: actions.SET_AUTH_IS_LOADING,
  payload: isLoading
});



export const updateCurrnetUserSettingsAction = (id, formData) => ({
  type: actions.AUTH_UPDATE_USER_SETTINGS,
  payload: {
    id,
    formData,
  },
});


export const updateCurrentUserSettingsSuccessAction = (user) => ({
  type: actions.AUTH_UPDATE_USER_SETTINGS_SUCCESS,
  payload: user,
});


export const updateCurrnetUserAction = (id, formData) => ({
  type: actions.AUTH_UPDATE_USER,
  payload: {
    id,
    formData,
  },
});


export const updateCurrentUserSuccessAction = (user) => ({
  type: actions.AUTH_UPDATE_USER_SUCCESS,
  payload: user,
});